module.exports = __webpack_public_path__ + "static/media/logo.b4993e35.png";